"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineNonEnumerable = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types
function defineNonEnumerable(target, propName, value) {
    Object.defineProperty(target, propName, {
        value: value,
        enumerable: false
    });
}
exports.defineNonEnumerable = defineNonEnumerable;

//# sourceMappingURL=object-utils.js.map
